import React, { useEffect, useRef } from "react"; 
import { Link, useNavigate } from "react-router-dom"; 
import { Calendar, User, ArrowRight } from "lucide-react";
import "aos/dist/aos.css";

const BlogList = () => {
  const navigate = useNavigate();
  const clickedBlogs = useRef({}); 


  useEffect(() => {
    import("aos").then((AOS) => {
      AOS.default.init({ duration: 500, once: true });
    });
    window.scrollTo(0, 0);
  }, []);

  const blogs = [
    {
      id: 1,
      title: "Top 5 Benefits of Playing Browser Games",
      excerpt: "Browser games are not just for fun. Discover how playing HTML5 games can improve your reflexes, strategic thinking, and stress relief without any downloads.",
      date: "Jan 28, 2026",
      author: "Game Zone Editor", 
      image: "https://images.unsplash.com/photo-1552820728-8b83bb6b773f?q=80&w=900&auto=format&fit=crop",
      slug: "benefits-of-browser-games"
    },
    {
      id: 2,
      title: "Why HTML5 Games are the Future of Gaming",
      excerpt: "Gone are the days of heavy installations. Learn why HTML5 technology is revolutionizing the gaming industry and allowing you to play free online instantly.",
      date: "Jan 25, 2026",
      author: "Tech Desk",
      image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=900&auto=format&fit=crop",
      slug: "html5-games-future"
    },
    {
      id: 3,
      title: "Best Racing Games to Play Online in 2026",
      excerpt: "Looking for speed? We have curated a list of the most thrilling and high-speed racing games available to play free online on Game Zone Hub.",
      date: "Jan 20, 2026",
      author: "Game Zone Team",
      image: "https://images.unsplash.com/photo-1511512578047-dfb367046420?q=80&w=900&auto=format&fit=crop",
      slug: "best-racing-games-2026"
    }
  ];



  return (
    <div id="blog-section" className=" bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] sm:pt-[70px] pt-[50px] pb-20 ">
      

      <div className="container mx-auto px-4">
        <div className="text-center mb-16" data-aos="fade-down">
          <h2 className="text-3xl sm:text-5xl font-extrabold text-white mb-4">
            Gaming <span className="text-blue-500">Blog</span> & News
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Stay updated with the latest trends, tips, and reviews for your favorite <strong>free online games</strong> at Game Zone Hub.
          </p>
        </div>

        <div className="mb-10"></div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogs.map((blog, index) => (
            <div 
              key={blog.id} 
              className="bg-[#1e293b] rounded-2xl overflow-hidden border border-white/5 hover:border-blue-500/30 transition-all duration-300 group hover:-translate-y-2 shadow-lg"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={blog.image} 
                  alt={`${blog.title} - Game Zone Hub Blog`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  loading="lazy"
                />
                <div className="absolute top-4 left-4 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full">
                  News
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex items-center gap-4 text-xs text-gray-400 mb-3">
                  <span className="flex items-center gap-1"><Calendar size={12}/> {blog.date}</span>
                  <span className="flex items-center gap-1"><User size={12}/> {blog.author}</span>
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3 line-clamp-2 group-hover:text-blue-400 transition-colors">
                  {blog.title}
                </h3>
                
                <p className="text-gray-400 text-sm mb-4 line-clamp-3">
                  {blog.excerpt}
                </p>
                
                <Link
                  to={`/blog/${blog.slug}`} 
                  className="inline-flex items-center gap-2 text-blue-400 font-semibold hover:text-blue-300 transition-colors text-sm cursor-pointer"
                  aria-label={`Read article: ${blog.title}`}
                >
                  Read Article <ArrowRight size={16}/>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>

      
    </div>
  );
};

export default BlogList;